import type { UseQueryOptions } from "react-query";
import {
  type AdStudioTemplateFoldersQuery,
  useAdStudioTemplateFoldersQuery,
} from "src/graphql";
import { useIsHightouchStaff } from "src/hooks/use-is-hightouch-staff";

export function useTemplateFolders(
  options?: UseQueryOptions<AdStudioTemplateFoldersQuery, Error>,
) {
  const isStaff = useIsHightouchStaff();
  return useAdStudioTemplateFoldersQuery(
    { visibilities: isStaff ? ["workspace", "private"] : ["workspace"] },
    options,
  );
}
